import classNames from "classnames";
import { ActionDiv, ActionDivProps } from "PFComponents/containers";
import { forwardRef, HTMLAttributes, ReactNode } from "react";

import css from "./card.module.scss";

type ConditionalCardProps =
  | Pick<ActionDivProps, "onClick" | "ariaLabel">
  | {
      onClick?: never;
      ariaLabel?: never;
    };

export type CardProps = {
  id?: string;
  children: ReactNode;
  qaId?: string;
  shadowVariant?: "none" | "default" | "inset";
  paddingVariant?: "none" | "sm" | "lg" | "xl";
  dark?: boolean;
  className?: string;
} & ConditionalCardProps &
  HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated Use Tile or ActionTile instead
 */
export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      ariaLabel,
      children,
      className,
      qaId = "Card",
      id,
      dark,
      shadowVariant = "default",
      paddingVariant = "lg",
      onClick,
      ...props
    },
    ref
  ) => {
    const renderWrapper = (content: ReactNode) =>
      onClick ? (
        <ActionDiv onClick={onClick} ariaLabel={ariaLabel} className={classNames(css.actionDiv, className)}>
          {content}
        </ActionDiv>
      ) : (
        content
      );

    return renderWrapper(
      <div
        id={id}
        ref={ref}
        data-qa-id={qaId}
        className={classNames(css.card, !onClick && className, {
          [css.noPadding]: paddingVariant === "none",
          [css.smallPadding]: paddingVariant === "sm",
          [css.largePadding]: paddingVariant === "lg",
          [css.xlargePadding]: paddingVariant === "xl",
          [css.shadowNone]: shadowVariant === "none",
          [css.shadowInset]: shadowVariant === "inset",
          [css.dark]: dark
        })}
        {...(props as any)}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";
